let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fNsQj")).then(() => parcelRequire('lJX99'));